<template>
  <div>
    <app-alert-in-page v-if="isPartialFilesAlertDisplayed" variant="warning" class="mb-2 mt-4">
      <p class="text-text-secondary">{{ $t('project.signing-checklist.add.step3.SigningChecklistAddStep3.partialFiles') }}</p>
    </app-alert-in-page>

    <PrepareSignature v-if="stepToPrepare" :step="stepToPrepare" :key="envelopeToPrepareIndex" />

    <p v-if="filteredImportedFiles.length === 0" class="text-center mt-4 text-text-secondary">
      {{ $t('project.signing-checklist.add.step3.SigningChecklistAddStep3.noValidFiles') }}
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'

import PrepareSignature from '@/project/signing-checklist/prepare-signature/PrepareSignature.vue'

export default defineComponent({
  name: 'SigningChecklistAddStep3',
  components: {
    PrepareSignature,
  },
  props: {
    envelopeToPrepareIndex: {
      type: Number,
      required: true,
    },
  },
  head () {
    return {
      title: this.$t('project.signing-checklist.add.step3.SigningChecklistAddStep3.metaTitle'),
    }
  },
  computed: {
    ...mapState('signingChecklist', ['importedFiles']),
    ...mapGetters('signingChecklist', ['importedFilesInDraft']),
    filteredImportedFiles () {
      return this.importedFilesInDraft
    },
    stepToPrepare () {
      if (this.filteredImportedFiles.length > 0) {
        return this.filteredImportedFiles[this.envelopeToPrepareIndex]
      }
      return null
    },
    isPartialFilesAlertDisplayed () {
      return this.filteredImportedFiles.length !== 0 && (this.importedFiles.length !== this.filteredImportedFiles.length)
    },
  },
})
</script>
